import React, { Component } from 'react';
import {toast } from 'react-toastify';
import cookie from 'react-cookies';
import $ from 'jquery';
import {updateValueInJson, esUrl} from '../../../../../functions';
import axios from 'axios';
import {API_URL} from '../../../../../constants';

export default class BuscadorPartidas extends Component {
    constructor(props) {

        super(props); 

        this.state = { 
            modulo: this.props.modulo,

            //data
            resource:{
                pagi_Id:this.props.pagina,
                pmod_Id:0,
                mweb_Id:this.props.modulo.id,

                mbpa_Titulo: "",
                pmod_ClaseAncla: "",

                mbpa_UsuarioCreacion:"",
                mbpa_Activo:true
            },
            resourceEdit:{
                pagi_Id:this.props.pagina,
                pmod_Id:0,
                mweb_Id:this.props.modulo.id,

                mbpa_Id: 0,

                mbpa_Titulo: "",
                pmod_ClaseAncla: "",

                mbpa_UsuarioCreacion:"",
                mbpa_Activo:true
            },
            Validacion: {
                mbpa_Titulo: {
                    Error: false,                    
                },
                pmod_ClaseAncla: {
                    Error: false,  
                }
            },
            ValidacionEdit:{
                mbpa_Titulo: {
                    Error: false,                    
                },
                pmod_ClaseAncla: {
                    Error: false,  
                }
            },


            // more
            perfiles: this.props.perfiles,
            sectores: this.props.sectores,

            herramientaAnalisis: this.props.herramientaAnalisis,

            hasError:false,
            added:false,
            confirmStore:false,
            security: cookie.load('user'),
            roles: []
        }

        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleInputChangeEdit = this.handleInputChangeEdit.bind(this);
    }

    closeModulo = () => {
        let resource = this.state.resource;
        let resourceEdit = this.state.resourceEdit;

        resource.pmod_Id = 0;
        resourceEdit.mbpa_Id = 0;

        this.setState({
            resource:resource, 
            resourceEdit:resourceEdit,
            Validacion: {
                mbpa_Titulo: {
                    Error: false,                    
                },
                pmod_ClaseAncla: {
                    Error: false,  
                }
            },
            ValidacionEdit:{
                mbpa_Titulo: {
                    Error: false,                    
                },
                pmod_ClaseAncla: {
                    Error: false,  
                }
            }
        });
        this.props.callback(true);
    }

    storeModulo = (e) => {

        if(e != undefined){
            e.preventDefault();
        }

        let newState = this.state;
        newState.hasError = false;

        if (newState.resource.mbpa_Titulo == '') {              
            newState.Validacion.mbpa_Titulo = {Error: true};
            newState.hasError = true;
        }

        if(newState.hasError){
            this.setState(newState);
            return;
        }

        const url = `${API_URL}ModuloBuscadorPartidasUX/`;
        var dataForm = this.state.resource;
        dataForm = updateValueInJson(dataForm,'mbpa_UsuarioCreacion', this.state.security.nUsuCodigo);

        const formData = JSON.stringify(dataForm);

        axios.post(url, JSON.stringify(formData),{ 
            headers: {
                'Content-Type': 'application/json; charset=UTF-8' ,
                'Accept': 'application/json'
            }
        }).then( (data)=> {
            if (data.data.isSucess){

                let result = data.data.result;
                let stateResponse = this.state;

                stateResponse.added = true;
                stateResponse.resource.mbpa_Titulo = '';

                stateResponse.resource.pmod_Id = result.pmod_Id;

                document.getElementById("pweb_Id").selectedIndex = 0;
                this.setState(stateResponse);

                setTimeout(() => { 
                    this.setState({added:false});
                }, 3000); 

                this.props.callback(true);
                $(".divClosePopup_Modals").trigger("click");

            }else {
                this.setState({
                    hasErrorProceso:true
                });

                setTimeout(() => { 
                    this.setState({
                        hasErrorProceso:false
                    });
                }, 3000); 
            }

        }).catch((error)=> {
            console.log('Error no controlado.');
            this.setState({loading:false});
        });

    }

    updateModulo = (e) => {

        if(e != undefined){
            e.preventDefault();
        }

        let newState = this.state;
        newState.hasError = false;

        if (newState.resourceEdit.mbpa_Titulo === '' || !newState.resourceEdit.mbpa_Titulo) {              
            newState.ValidacionEdit.mbpa_Titulo = {Error: true};
            newState.hasError = true;
        }

        if(newState.hasError){
            this.setState(newState);
            return;
        }

        const url = `${API_URL}ModuloBuscadorPartidasUX/`;
        var dataForm = this.state.resourceEdit;
        // dataForm = updateValueInJson(dataForm,'mbim_UsuarioEdicion', this.state.security.nUsuCodigo);

        const formData = JSON.stringify(dataForm);

        axios.put(url, JSON.stringify(formData),{ 
            headers: {
                'Content-Type': 'application/json; charset=UTF-8' ,
                'Accept': 'application/json'
            }
        }).then( (data)=> {

            if (data.data.isSucess){
                this.setState({added:true});

                setTimeout(() => { 
                    this.setState({added:false});
                }, 3000); 
            
            } else {
                this.setState({
                    hasErrorProceso:true
                });

                setTimeout(() => { 
                    this.setState({
                        hasErrorProceso:false
                    });
                }, 3000); 
            }

        }).catch((error)=> {
            console.log('Error no controlado.');
            this.setState({loading:false});
        });    
    }

    loadModulo = (pmod_Id) => {
        const url = `${API_URL}ModuloBuscadorPartidasUX/Seleccionar/${pmod_Id}`;

        axios.get(url).then(response => response.data)
        .then((data) => {
            this.setState({ 
                resourceEdit: data.result, 
                response:     data, 
                error:        data.Error 
            });           
        })
        .catch(error => {
            console.log("¡Error al inicializar!");
        });
    } 

    componentWillReceiveProps(nextProps){

        let mweb = 68;

        if(nextProps.pmodId !== this.state.resource.pmod_Id && mweb == nextProps.mWebEdit){

            let resource = this.state.resource;
            resource.pmod_Id = nextProps.pmodId;

            this.setState({
                resource: resource
            });

            setTimeout(() => { 
                this.loadModulo(resource.pmod_Id);
            }, 100); 
            
        }
    } 

    handleInputChange(event) {

        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        let copyResource = this.state.resource;
        copyResource[target.name] = value;

        let validaciones = this.state.Validacion;

        validaciones[target.name] = {
            Error: false,                    
        }

        this.setState({
            resource: copyResource,
            Validacion: validaciones
        });  
    }

    handleInputChangeEdit(event) {

        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;

        let copyResource            = this.state.resourceEdit;
        copyResource[target.name]   = value;

        let validaciones = this.state.ValidacionEdit;

        validaciones[target.name] = {
            Error: false,                    
        }

        this.setState({
            resourceEdit: copyResource,
            ValidacionEdit: validaciones
        });  
    }

    render() {

        let modulo = this.state.modulo;
        console.log(this.state);

        return ( 
            <div className="divModalBanner popUpGeneral" id={"modal_" + modulo.id} style={{display:"none"}}>
                <div className="divLayerPopup_ModalPaginas">
                    <div className="divPopup_ModalPaginas">
                        <div className="divClosePopup_Modals" onClick={() => this.closeModulo()} />
                        <h2>{modulo.nombre} </h2>
                        <div className="divWrapperModalPaginas">

                            {this.state.resourceEdit.mbpa_Id > 0 ?
                                <React.Fragment>
                                    {/* EDIT */}
                                    <div className="containerFormCreation divModuloPopup_Panel">

                                        {this.state.added ?
                                            <div className="txtFile x-1">
                                                <strong style={{
                                                    display: "block",
                                                    textAlign:"center",
                                                    color: "#008000a3"
                                                }}> 
                                                    Registro actualizado satisfactoriamente!!
                                                </strong>
                                            </div> 
                                            : null
                                        }

                                        <div className="textareaResumen x-1">
                                            <input 
                                                type="text" 
                                                placeholder="Título" 
                                                value={this.state.resourceEdit.mbpa_Titulo ? this.state.resourceEdit.mbpa_Titulo : ""} 
                                                name="mbpa_Titulo"  
                                                className={this.state.ValidacionEdit.mbpa_Titulo.Error ? "error" : ""}
                                                onChange={this.handleInputChangeEdit} 
                                                maxLength={100} 
                                            />
                                        </div>

                                        <div className="divModulo_Seo">
                                            <h2>
                                                <strong>Configuración de modulo</strong>
                                            </h2>
                                            <div className="divWrapperModulo_Seo">
                                                <div className="textareaResumen x-1">
                                                    <input 
                                                        type="text" 
                                                        placeholder="Anclaje del modulo" 
                                                        value={this.state.resourceEdit.pmod_ClaseAncla ? this.state.resourceEdit.pmod_ClaseAncla : ""} 
                                                        name="pmod_ClaseAncla"  
                                                        className={this.state.ValidacionEdit.pmod_ClaseAncla.Error ? "error" : ""}
                                                        onChange={this.handleInputChangeEdit} 
                                                        maxLength={100} 
                                                    />
                                                </div>  
                                            </div>   
                                        </div>       

                                    </div>
                                    <div>
                                        <a href="" className="btnAgregarPagina noneEvent" id="btnActualizarPerfiladorBuscadorPartida" onClick={(e) => this.updateModulo(e)}>ACTUALIZAR</a>
                                        <br/>
                                        <br/>
                                        <br/>
                                    </div>
                                </React.Fragment>
                                :
                                <React.Fragment>
                                    {/* ADD */}
                                    <div className="containerFormCreation divModuloPopup_Panel">
                                        <div className="textareaResumen x-1">
                                            <input 
                                                type="text" 
                                                placeholder="Título" 
                                                value={this.state.resource.mbpa_Titulo} 
                                                name="mbpa_Titulo"  
                                                className={this.state.Validacion.mbpa_Titulo.Error ? "error" : ""}
                                                onChange={this.handleInputChange} 
                                                maxLength={100} 
                                            />
                                        </div>

                                        <div className="divModulo_Seo">
                                            <h2>
                                                <strong>Configuración de modulo</strong>
                                            </h2>
                                            <div className="divWrapperModulo_Seo">
                                                <div className="textareaResumen x-1">
                                                    <input 
                                                        type="text" 
                                                        placeholder="Anclaje del modulo"
                                                        value={this.state.resource.pmod_ClaseAncla} 
                                                        name="pmod_ClaseAncla"  
                                                        className={this.state.Validacion.pmod_ClaseAncla.Error ? "error" : ""}
                                                        onChange={this.handleInputChange} 
                                                        maxLength={100} 
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div>
                                        <a href="" className="btnAgregarPagina noneEvent" id="btnGuardarPerfiladorBuscadorPartida" onClick={(e) => this.storeModulo(e)}>GUARDAR</a>
                                        <br/>
                                        <br/>
                                        <br/>
                                    </div>
                                </React.Fragment>
                            }

                        </div>
                    </div>
                </div>
            </div>
        )
    }
}